/**
 * @class
 */
class EnvUtils {
  /**
   * 获取env
   * @returns {string}
   */
  static getEnv() {
    return process.env.NODE_ENV;
  }
}

export default  EnvUtils;



// WEBPACK FOOTER //
// ./node_modules/@xfe-team/utils/src/env-utils.js